module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


    const { id, masterValues, variantValues, renderData, position, score } = hit;

    const currencySign = document.querySelector( 'meta[name="_currency"]' ).content;
    const locale = document.documentElement.lang;

    const master = masterValues;
    const variant = variantValues[0];

    const masterId = masterValues.MastergroupID;

    const {
        link,
        color,
        colorLabel,
        isNew,
        isSale,
        onlineOnly,
        badges,
        discountPercent,
        images,
        initialSizes,
        colorDots
    } = renderData;

    const formatPrice = ( price ) => Intl.NumberFormat( locale === 'de-AT' ? 'de-DE' : locale, { minimumFractionDigits: 2 } ).format( price );
    const escAttr = ( item ) => item.split( '&' ).join( '&amp;' ).split( '<' ).join( '&lt;' ).split( '"' ).join( '&quot;' ).split( "'" ).join( '&#39;' );
;
__p += '\n<article class="en_mdl_product en_griditem is_hoverable" data-en-griditem-default="2-1" data-en-griditem-medium="3-1"\n         data-en-griditem-desktop="3-1" data-dy-sku="' +
((__t = ( variant.ProductID )) == null ? '' : __t) +
'" data-eec-id="' +
((__t = ( master.Artikelnummer )) == null ? '' : __t) +
'" data-eec-list="/shop-suche/"\n         data-eec-name="' +
((__t = ( escAttr( variant.Brand + ' ' + variant.Producttitle ) )) == null ? '' : __t) +
'" data-eec-price="' +
((__t = ( variant.Price )) == null ? '' : __t) +
'" data-eec-brand="' +
((__t = ( escAttr( variant.Brand ) )) == null ? '' : __t) +
'"\n         data-eec-currency="' +
((__t = ( currencySign )) == null ? '' : __t) +
'"\n         data-eec-oldprice="' +
((__t = ( variant.Price_old )) == null ? '' : __t) +
'"\n         data-ff-masterid="' +
((__t = ( masterId )) == null ? '' : __t) +
'"\n         data-ff-campaign="' +
((__t = ( master.__FFCampaign__ ?? '' )) == null ? '' : __t) +
'"\n         data-ff-score="' +
((__t = ( score )) == null ? '' : __t) +
'">\n    <div class="en_mdl_product__wrapper">\n        <div class="en_mdl_product__inner en_griditeminner">\n            <div class="en_mdl_product__image_cnt en_mdl_product__image_cnt--has_slider">\n                <a href="' +
((__t = ( link )) == null ? '' : __t) +
'" class="en_mdl_product__image_cnt_inner" data-en-ratio-default="3-4">\n                    <div class="en_mdl_product__image en_mdl_product__image--default en_mdl_product__image--slider">\n                        <div class="mdl_slider">\n                            <div class="mdl_slider__outer" data-en-ratio-default="3-4">\n                                <div class="mdl_slider__inner">\n                                    <ul class="mdl_slider__track">\n                                        ';
 images.forEach( ( image, idx ) => { ;
__p += '\n                                            <li class="mdl_slider__slide' +
((__t = ( idx === 0 ? ' is-active' : '' )) == null ? '' : __t) +
'">\n                                                <img class="en_mdl_product__image_img"\n                                                     src="' +
((__t = ( image )) == null ? '' : __t) +
'"\n                                                     alt="' +
((__t = ( variant.Brand )) == null ? '' : __t) +
' | ' +
((__t = ( variant.Producttitle )) == null ? '' : __t) +
' | ' +
((__t = ( colorLabel )) == null ? '' : __t) +
'"\n                                                     sizes="(max-width: 420px) 192px, 330px"\n                                                     srcset="' +
((__t = ( image )) == null ? '' : __t) +
' 192w, ' +
((__t = ( image )) == null ? '' : __t) +
' 330w"\n                                                     loading="lazy" width="330"\n                                                     height="440">\n                                            </li>\n                                        ';
 }) ;
__p += '\n                                    </ul>\n                                </div>\n                            </div>\n                            <div class="mdl_slider__pager en_hidden_no_touch">\n                                <div class="mdl_slider__pager-inner">\n                                    ';
 images.length > 1 && images.forEach( ( image, idx ) => { ;
__p += '\n                                        <div class="mdl_slider__pager-item' +
((__t = ( idx === 0 ? ' is-active' : '' )) == null ? '' : __t) +
'">\n                                            <button type="button" class="mdl_slider__pager-item-link" aria-label="Bild #' +
((__t = ( idx + 1 )) == null ? '' : __t) +
'"></button>\n                                        </div>\n                                    ';
 }) ;
__p += '\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="en_mdl_product__image en_mdl_product__image--alt" id="img_' +
((__t = ( id )) == null ? '' : __t) +
'_alt">\n                        ';
 colorDots.forEach( ( [dotColor, dotImage, dotLink, dotSizes], idx ) => { ;
__p += '\n                            <img\n                                class="en_mdl_product__image_img en_js_hide_onerror en_hidden"\n                                src="' +
((__t = ( dotImage )) == null ? '' : __t) +
'"\n                                alt="' +
((__t = ( variant.Brand )) == null ? '' : __t) +
' | ' +
((__t = ( variant.Producttitle )) == null ? '' : __t) +
' | ' +
((__t = ( dotColor && dotColor.length ? dotColor.split( '$$' )[0] : 'Keine Farbe' )) == null ? '' : __t) +
'" sizes="(max-width: 420px) 192px, 330px"\n                                srcset="' +
((__t = ( dotImage )) == null ? '' : __t) +
' 192w, ' +
((__t = ( dotImage )) == null ? '' : __t) +
' 330w"\n                                loading="lazy" id="img_' +
((__t = ( id )) == null ? '' : __t) +
'_color' +
((__t = ( idx )) == null ? '' : __t) +
'" width="330" height="440">\n                        ';
 }) ;
__p += '\n                    </div>\n\n                    <div class="en_mdl_product__badges en_badges en_badges--stacked">\n                        ';
 if ( isSale ) { ;
__p += '\n                        <div class="en_badge en_badge--sale en_format_bold salesPercentageBadge">\n                            ' +
((__t = ( discountPercent )) == null ? '' : __t) +
'%\n                        </div>\n                        ';
 } ;
__p += '\n                    </div>\n\n                    <div class="en_mdl_product__badges en_badges en_badges--bottom en_badges--stacked">\n                        ';
 if ( isNew && !isSale ) { ;
__p += '\n                            <div class="en_badge en_format_bold">NEU</div>\n                        ';
 } ;
__p += '\n\n                        ';
 badges.forEach( ( { name, title, prio, cssicon }, idx ) => { ;
__p += '\n                            <div class="en_badge ' +
((__t = ( cssicon )) == null ? '' : __t) +
'">' +
((__t = ( title )) == null ? '' : __t) +
'</div>\n                        ';
 }) ;
__p += '\n\n                        ';
 if ( onlineOnly ) { ;
__p += '\n                            <div class="en_badge en_badge--online_only">Nur Online</div>\n                        ';
 } ;
__p += '\n                    </div>\n\n                </a>\n\n                ';
 if ( userdata?.data?.user?.loggedIn ) { ;
__p += '\n                    <a href="' +
((__t = ( wishlistLink )) == null ? '' : __t) +
'" class="en_mdl_product__wishlist-button js_toggle_wishlistproduct ' +
((__t = ( onWishlist ? 'is-on-wishlist' : '' )) == null ? '' : __t) +
'" data-aid="' +
((__t = ( variant.ProductID )) == null ? '' : __t) +
'" title="Auf die Wunschliste" rel="nofollow"> </a>\n                ';
 } else { ;
__p += '\n                    <a href="' +
((__t = ( wishlistLink )) == null ? '' : __t) +
'" class="en_mdl_product__wishlist-button en_js_open_popup" data-aid="' +
((__t = ( variant.ProductID )) == null ? '' : __t) +
'" data-en-popup-target="#popup_login_register" title="Auf die Wunschliste" rel="nofollow"> </a>\n                ';
 } ;
__p += '\n\n                <a href="' +
((__t = ( link )) == null ? '' : __t) +
'" class="en_mdl_product__cart-button en_js_open_popup acl_js_load_popup" data-en-popup-target="#popup_article"></a>\n\n            </div>\n            <div class="en_mdl_product__content_cnt">\n                <a href="' +
((__t = ( link )) == null ? '' : __t) +
'" class="en_mdl_product__content ">\n                    <h3 class="en_mdl_product__header en_heading_h5">\n                        <div class="en_mdl_product__label">' +
((__t = ( variant.Brand )) == null ? '' : __t) +
'</div>\n                        <div class="en_mdl_product__name">' +
((__t = ( variant.Producttitle )) == null ? '' : __t) +
'</div>\n                    </h3>\n\n                    <div class="en_mdl_product__price en_spacer_top_small">\n                        ';
 if ( isSale ) { ;
__p += '\n                            <span class="en_price_uvp">UVP&nbsp;</span>\n                            <span class="en_price en_price--old">\n                                <span class="en_price__currency">' +
((__t = ( currencySign )) == null ? '' : __t) +
'</span>\n                                ' +
((__t = ( formatPrice( variant.Price_old ) )) == null ? '' : __t) +
'\n                            </span>\n                            <span class="en_price en_price--new">\n                                <span class="en_price__currency">' +
((__t = ( currencySign )) == null ? '' : __t) +
'</span>\n                                ' +
((__t = ( formatPrice( variant.Price ) )) == null ? '' : __t) +
'\n                            </span>\n                        ';
 } else { ;
__p += '\n                            <span class="en_price">\n                                <span class="en_price__currency">' +
((__t = ( currencySign )) == null ? '' : __t) +
'</span>\n                                ' +
((__t = ( formatPrice( variant.Price ) )) == null ? '' : __t) +
'\n                            </span>\n                        ';
 } ;
__p += '\n                    </div>\n                </a>\n                ';

                if ( colorDots.length > 1 ) { ;
__p += '\n                    <div class="en_mdl_product__colors en_grid en_spacer_top_tiny acl_color_hover">\n                        ';
 colorDots.forEach( ( [dotColor, dotImage, dotLink, dotSizes], idx ) => {
                            const swap = {
                                scope: '#img_' + id + '_alt',
                                target: '.en_mdl_product__image_img',
                                attribute: 'id',
                                value: 'img_' + id + '_color' + idx
                            }; ;
__p += '\n                            <a\n                                class="en_mdl_product__color colorbutton ' +
((__t = ( color === dotColor ? 'en_is_active' : '' )) == null ? '' : __t) +
'"\n                                href="' +
((__t = ( dotLink )) == null ? '' : __t) +
'"\n                                data-en-sizes=\'' +
((__t = ( JSON.stringify( dotSizes ) )) == null ? '' : __t) +
'\'\n                                data-en-image-swap=\'' +
((__t = ( JSON.stringify( swap ) )) == null ? '' : __t) +
'\'>\n                                <div class="en_mdl_product__color-inner colorbutton_inner" data-acl-color="' +
((__t = ( dotColor && dotColor.length ? dotColor.split( '$$' )[0] : 'Keine Farbe' )) == null ? '' : __t) +
'"></div>\n                            </a>\n                        ';
 }); ;
__p += '\n                        <a class="en_mdl_product__colors-morelink en_hidden" href="' +
((__t = ( link )) == null ? '' : __t) +
'"></a>\n                    </div>\n                ';
 } ;
__p += '\n                ';
 if ( initialSizes.length > 0 ) { ;
__p += '\n                <div class="en_mdl_product__content en_mdl_product__content--hover">\n                    <div class="en_mdl_product__sizes en_spacer_top en_text_infotext">\n                        <strong>Verfügbare Größen:</strong>\n                        <div class="en_mdl_product__sizes_inner">\n                            ';
 initialSizes.forEach( ( size ) => { ;
__p += '\n                                <div class="en_mdl_product__sizes_size">' +
((__t = ( size )) == null ? '' : __t) +
'</div>\n                            ';
 }) ;
__p += '\n                        </div>\n                    </div>\n                </div>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n</article>\n';

}
return __p
};
